"use client";
import { socialMediaPlatforms } from "@/data/main-data";
import { useGetAgents } from "@/hooks/main-hook";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import Paginate from "../paginate/paginate";

export default function AllAgents() {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useGetAgents({ page: currentPage, limit: 20 });

  const totalPages = data?.paginate?.totalPages ?? 1;

  const agents = data?.agents || [];

  return (
    <div className="mt-8 ">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 pb-8">
        {isLoading ? (
          <>
            {[...Array(8)].map((_, index) => (
              <AgentCardSkeleton key={index} />
            ))}
          </>
        ) : (
          agents?.map((agent: any) => (
            <div
              key={agent.id}
              className="bg-white shadow px-4 py-2 border border-gray-200 rounded-xl"
            >
              <Link
                href={`/agents/${agent.slug}`}
                className="flex justify-center"
              >
                <Image
                  src={agent?.user?.photo || "/user.webp"}
                  alt={agent.user?.username}
                  width={400}
                  height={300}
                  priority
                  className="rounded-b-full"
                />
              </Link>
              <h3 className="text-lg font-semibold mt-3 text-center text-dark capitalize">
                {agent.user?.username}
              </h3>

              <ul className="flex items-center justify-center gap-4 py-4">
                {agent.social_links.map((social: any, index: number) => {
                  const socialIcons = socialMediaPlatforms.find(
                    (e) => e.value === social.platform
                  );

                  return (
                    <li
                      key={index}
                      className="border  rounded-full border-main hover:bg-main hover:text-white duration-500"
                    >
                      <Link
                        href={social.url}
                        target="_blank"
                        rel="noreferrer"
                        className="p-2 block"
                      >
                        {socialIcons && <socialIcons.icon size={20} />}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))
        )}
      </div>

      {agents?.length > 0 && totalPages > 0 && (
        <Paginate
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
}

export const AgentCardSkeleton = () => {
  return (
    <div className="bg-white shadow px-4 py-2 animate-pulse">
      <div className="flex justify-center">
        <div className="rounded-b-full bg-gray-300 w-[400px] h-[300px]"></div>
      </div>

      <div className="mt-3 h-5 w-32 bg-gray-300 mx-auto rounded"></div>

      <ul className="flex items-center justify-center gap-4 py-4">
        {[1, 2, 3].map((i) => (
          <li
            key={i}
            className="border rounded-full border-gray-300 p-2 bg-gray-200 w-10 h-10"
          ></li>
        ))}
      </ul>
    </div>
  );
};
